import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__legal">{t("common.footer.legal")}</p>

        <p className="site-footer__copyright">{t("common.footer.copyright")}</p>
      </div>
    </footer>
  );
}
